import './styles/aiChat.css';
import './styles/branding.css';
import './styles/themes.css';
import './styles/dashboard.css';
import './styles/help.css';
import './styles/helper.css';
import './styles/journal.css';
import './styles/landing.css';
import './styles/main.css';
import './styles/modal.css';
import './styles/navbar.css';
import './styles/scanner.css';
import './styles/toast.css';
import './styles/ui.css';
import './styles/features.css';
import { AuthTokenPayload } from './interfaces.js';
import { installCsrfFetchGuard } from './csrf.js';
import { installSessionExpiryHandler } from './sessionExpiry.js';
import App from './app.js';

// Before any page code runs: every same-origin mutating fetch carries the CSRF token
// the unified host requires, even if a call site forgot to add it (see csrf.ts).
installCsrfFetchGuard();
// ...and if a token refresh can't help because the session itself is gone, prompt for sign-in
// without navigating away from unsaved work.
installSessionExpiryHandler();

document.addEventListener('DOMContentLoaded', App.init);

declare global {
	interface Window {
		google: any;
		user: AuthTokenPayload | null;
		Toast: any;
	}
}
